import * as i0 from "@angular/core";
export class IsSharedWithOthersPipeModule {
}
IsSharedWithOthersPipeModule.ɵfac = function IsSharedWithOthersPipeModule_Factory(t) { return new (t || IsSharedWithOthersPipeModule)(); };
IsSharedWithOthersPipeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IsSharedWithOthersPipeModule });
IsSharedWithOthersPipeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
